import React from 'react';
import PropTypes from 'prop-types'
import { Field } from 'redux-form';
import renderTextField from '../../components/MaterialUi/renderTextField';
import RFCheckboxField from '../../components/ReduxFormComps/RFCheckboxField';

const RFTextOverrideRequireField=(props)=>{
    const { 
        overrideCheckBoxFieldName,overrideCheckBoxLabel,
        label,fieldName,customStyle } = props

    return (
        <div>
            {!props[overrideCheckBoxFieldName]?(
                <Field
                    name={fieldName}
                    component={renderTextField}
                    label={label}
                    style={customStyle}
                />
            ):null}
            
            <Field 
                name={overrideCheckBoxFieldName} 
                component={RFCheckboxField} 
                label={overrideCheckBoxLabel}
            />
        </div>    
    )
}

RFTextOverrideRequireField.propTypes = {
    label: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    overrideCheckBoxFieldName: PropTypes.string.isRequired,
    overrideCheckBoxLabel: PropTypes.string.isRequired,
    customStyle: PropTypes.object
}

export default RFTextOverrideRequireField


// WEBPACK FOOTER //
// ./src/components/ReduxFormComps/RFTextOverrideRequireField.js